export const SALES_MANAGER = 'SalesManager';

export type UserRole = 'salesperson' | 'desking_manager';
